import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import InputControl from '~/components/Input/InputControl';
import InputSelect from '~/components/Input/InputSelect';

import { editFilter } from '../../../../store/actions';

function InputBoolean({
  filter,
  indexGroup,
  indexFilter,
  inputProps,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const options = useMemo(() => ([
    { id: true, name: t('true') },
    { id: false, name: t('false') },
  ]), [t]);

  return (
    <InputControl
      value={filter.get('value')}
      name={'value'}
      inputComponent={InputSelect}
      InputProps={{
        placeholder: t('filter-label-value'),
        outValueType: 'bool',
        options,
        ...inputProps,
      }}
      onChange={({ value }) => dispatch(editFilter(indexGroup, indexFilter, 'value', value))}
    />
  );
}

export default React.memo(InputBoolean);
